//import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"

export const TagBox = styled.span`
  display: inline-flex;
  padding: 6px;
  border-radius: 2px;
  width: fit-content;
  white-space: nowrap;
  @media screen and (min-width: 1024px) {
    padding: 8px;
  }

  > span {
    line-height: 1 !important;
    transform: translateY(1px);
  }
`
